import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[boiApplyCssOnScrollDirective]'
})
export class ApplyCssOnScrollDirective {
  @Input() public scrollOffSet: number;
  @Input() public cssClass: string;

  constructor(private readonly element: ElementRef, private readonly renderer: Renderer2) {}

  @HostListener('window:scroll')
  onScrollEvent(): void {
    const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    if (scrollTop > this.scrollOffSet) {
      this.renderer.addClass(this.element.nativeElement, this.cssClass);
    } else {
      this.renderer.removeClass(this.element.nativeElement, this.cssClass);
    }
  }
}
